import {
	InitSignupPayload,
	InitSignupResponse,
	LoginManagementPayload,
	ResultLoginManagement,
	UpdateUserProfileRequest,
	UpdateUserResponse,
	UserRbacResponse,
	UserResponse,
} from "@/modules/authentication";
import { axiosInstance } from "../common/axiosInstance";
import { ApiUrl } from "../common/apiUrl";
import axios from "axios";

export const initSignup = async (payload: InitSignupPayload): Promise<InitSignupResponse> => {
	const res = await axiosInstance().get<InitSignupResponse>(`authentication/oidc/login`, {
		params: {
			...payload,
		},
	});
	return res.data;
};

export const validateToken = async (): Promise<UserResponse> => {
	const res = await axiosInstance(ApiUrl.AZURE_SERVICE_URL).post<UserResponse>(`idm/user/getUserProfile`);

	return res.data;
};

export const managementLogin = async (payload: LoginManagementPayload): Promise<ResultLoginManagement> => {
	const res = await axiosInstance().post<ResultLoginManagement>(`authentication/management/login`, payload);
	return res.data;
};

export const getUserRbac = async (userId: number): Promise<UserRbacResponse> => {
	const { data } = await axiosInstance().get<UserRbacResponse>(`administration/rbac/users/${userId}/role`);
	return data;
};

export const updateUserProfile = async (payload: UpdateUserProfileRequest): Promise<UpdateUserResponse> => {
	const { file, ...rest } = payload;

	const { data } = await axiosInstance(ApiUrl.AZURE_SERVICE_URL).post<UpdateUserResponse>(`/api/editUserProfile`, rest);

	if (!data?.Response) {
		throw new Error("Failed to update user profile");
	}

	if (file && data.PresignedFormDataProfilePhoto) {
		const s3payload = data.PresignedFormDataProfilePhoto.fields;

		s3payload["file"] = file;
		await axios.post(data.PresignedFormDataProfilePhoto.url, s3payload, {
			headers: {
				"Content-Type": "multipart/form-data",
			},
		});
	}

	return data;
};
